/**
 *
 * @param {number} current Current number
 * @param {number} previous Previous number
 * @returns Percentage difference betweet previous and current number
 */
export function getPercentageDifference(current, previous) {
  if (isNaN(current) || isNaN(previous)) return 0;
  return (((current - previous) / previous) * 100).toFixed(1);
}
